import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../../../dashboard/redux/dashboardActions';
import { Button } from '../../../../../common/components';
import Markdown from 'react-markdown';
import { bindActionCreators } from 'redux';
import { Modal } from 'react-bootstrap';

const Attachments = ({ attachments }) => {
  if (!attachments) {
    return null;
  }

  return (
    <>
      <p className="note-attachments">
        <strong>Attachment(s): </strong>
      </p>
      <ul>
        {Object.entries(attachments).map((data, key) => {
          return (
            <li>
              <span className="attachment-link" key={key}>
                <a href={data[1].url} target="_blank">
                  {data[1].name}
                </a>
                &nbsp;
              </span>
            </li>
          );
        })}
      </ul>
    </>
  );
};

const Announcements = ({ announcements, actions }) => {
  const [announcement, setAnnouncement] = useState({
    title: '',
    message: '',
    attachments: {},
  });
  const [showAnnouncement, setShowAnnouncement] = useState(false);

  useEffect(
    () => {
      actions.fetchAnnouncements();
    },
    [actions],
  );

  const openAnnouncementModal = (announcement) => () => {
    if (!announcement) {
      return;
    }
    setAnnouncement({
      title: announcement.attributes.name,
      message: announcement.attributes.sections.content,
      attachments: announcement.attributes.sections.attachments,
    });
    setShowAnnouncement(true);
  };

  const handleHideModal = () => {
    setShowAnnouncement(false);
  };

  const enabled = announcements.data;

  return (
    <div>
      <table className="table reminders-list">
        <thead />
        <tbody>
          {enabled &&
            enabled.map((announcement) => {
              return (
                <tr key={announcement.id}>
                  <td className="reminder-date">{announcement.attributes.name}</td>
                  <td>
                    <Markdown source={announcement.attributes.sections.preview} />
                  </td>
                  <td className="reminder-action">
                    <Button
                      size="sm"
                      bsStyle="link"
                      label="more details"
                      handleClick={openAnnouncementModal(announcement)}
                    />
                  </td>
                </tr>
              );
            })}

          {enabled && enabled.length === 0 && (
            <tr key={1}>
              <td colSpan="2">You have no announcements</td>
              <td />
            </tr>
          )}
        </tbody>
      </table>
      <Modal show={showAnnouncement} onHide={handleHideModal}>
        <Modal.Header>
          <Modal.Title closeButton>{announcement.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Markdown source={announcement.message} />
          <Attachments attachments={announcement.attachments} />
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle={'primary'} label={'Close'} handleClick={handleHideModal} />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default connect(
  (state) => ({
    announcements: state.dashboard.announcements,
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
    dispatch,
  }),
)(Announcements);
